import { ShieldAlert, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AdminDenied() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid place-items-center bg-slate-950 text-white px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-500/20 border border-red-500/40 grid place-items-center mx-auto">
          <ShieldAlert className="w-8 h-8 text-red-400" />
        </div>
        <h1 className="font-heading text-3xl font-semibold tracking-tight mt-6">Accès refusé</h1>
        <p className="mt-4 text-slate-400 leading-relaxed">
          Le compte <strong className="text-white">{user?.email}</strong> n'est pas autorisé
          à accéder à l'espace administrateur.
        </p>
        <Button
          onClick={async () => { await logout(); navigate("/admin/login", { replace: true }); }}
          variant="outline"
          data-testid="denied-logout"
          className="mt-8 rounded-full border-white/30 text-white hover:bg-white/10 hover:text-white h-12 px-6"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Changer de compte
        </Button>
      </div>
    </div>
  );
}
